import { useEffect, useState } from 'react';

export const GreenHouseAPI = () => {
  const [fetchedData, setFetchedData] = useState();
  const [loading, setLoading] = useState(true);
  const url = 'https://api.greenhouse.io/v1/boards/glossier/jobs?content=true';

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response = await fetch(url);
        response = await response.json();
        setFetchedData(response);
        setLoading(false);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  return { fetchedData, loading };
};
